import React from "react";

const CPP_Ctime = () => {
  return (
    <div>
      <h1>CPP_Ctime Component</h1>
      <p>Content for CPP_Ctime goes here...</p>
    </div>
  );
};

export default CPP_Ctime;
